<div class="banner__section">
  <app-home-banner (scrollToSection)="scrollToEvaluateSkills()" [bannerList]="bannerList"></app-home-banner>
</div>
<app-support-journey [userLoggedIn]="userLoggedIn"></app-support-journey>
<!-- sport journey section -->
<app-multi-element-identity
  [topSportSequence]="topSportSequence"
  [userLoggedIn]="userLoggedIn"
  (exploreClick)="onExploreClick()"
  (evaluateClick)="scrollToEvaluateSkills()"
></app-multi-element-identity>
<!-- sport journey section -->
<app-sports-marquee></app-sports-marquee>

<app-sports-explorer [userLoggedIn]="userLoggedIn" (exploreClick)="onExploreClick()"></app-sports-explorer>

<section #evaluateSkillsSection id="evaluateSkillsSection" class="evaluateSkill" [ngClass]="userLoggedIn ? 'd-none' : ''">
  <ng-template #childContainer> </ng-template>
</section>

<!-- The System & The Uniform Section -->
<app-the-system [userLoggedIn]="userLoggedIn" (evaluateClick)="scrollToEvaluateSkills()" (exploreClick)="onExploreClick()"></app-the-system>

<!-- <app-evaluate-skills #evaluateSkillsSection id="evaluateSkillsSection" [ngClass]="userLoggedIn ? 'd-none' : ''"></app-evaluate-skills> -->
<!-- feed section -->
<ng-container *ngIf="userLoggedIn && expertUser">
  <section class="pendingFeeds" [hidden]="feedList == 0">
    <div class="container-fluid">
      <div class="feed-sec">
        <div class="feature-section_heading full__width guestContainer">
          <div class="guestContent">
            <h2 class="secondary__heading">Pending feeds for your review</h2>
            <p class="content_des">Shape the Rankings! Add Your Scores to the Feeds That Need Your ExpertJudgment</p>
          </div>
          <a routerLink="/feed/review" *ngIf="feedList > 3" class="common--button_unfill border--grey postion__right">View all</a>
        </div>
        <app-featured-feed [usedFor]="'PendingReview'" (feeds)="feedList = $event"></app-featured-feed>
      </div>
    </div>
  </section>
</ng-container>

<!-- Discover Events Section -->
<app-discover-events [userLoggedIn]="userLoggedIn"></app-discover-events>

<!-- featured feed -->
<ng-container *ngIf="userLoggedIn && expertUser">
  <section class="featFeed common__spacing--between-section grey__background" [hidden]="featuredFeedList == 0">
    <div class="container-fluid">
      <div class="feed-sec">
        <div class="feature-section_heading full__width guestContainer">
          <div class="guestContent">
            <h2 class="secondary__heading">Featured Feed</h2>
            <p class="content_des">Standout Performances</p>
          </div>
          <button (click)="viewAll('/featureFeed', 'feed')" *ngIf="featuredFeedList > 3" class="common--button_unfill border--grey postion__right">
            View all
          </button>
        </div>
        <app-featured-feed [usedFor]="'home'" (feeds)="featuredFeedList = $event"></app-featured-feed>
      </div>
    </div>
  </section>
</ng-container>
<!-- xdge store section -->
<app-shop-gear></app-shop-gear>

<!-- ads -->
<!-- <section class="common__spacing--between-section grey__background adshome" *ngIf="userLoggedIn && expertUser">
  <div class="container-fluid">
    <app-ads></app-ads>
  </div>
</section> -->

<!-- News section -->
<section class="latUpdates common__spacing--between-section" *ngIf="userLoggedIn">
  <div class="container-fluid">
    <div class="feature-section_heading full__width guestContainer">
      <div class="guestContent">
        <h2 class="secondary__heading">Latest News</h2>
      </div>
      <button (click)="viewAll('/media', '')" class="common--button_unfill border--grey postion__right">View all</button>
    </div>
    <app-common-news (xdge)="xdgeNewsList = $event" [usedFor]="'home'"></app-common-news>
  </div>
</section>
<app-tab-to-top></app-tab-to-top>
<app-sports-marquee></app-sports-marquee>
